import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import { SELECT_ITEM_DEFAULT, IS_ENTERPRISE } from 'config';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

export default class SelectTinhTrangHoatDong extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
  };

  componentWillMount = async () => {
    const datasource = [
      {_id: 'HOAT_DONG_BINH_THUONG', Name: 'Hoạt động bình thường'},
      {_id: 'NGUNG_HOAT_DONG', Name: 'Ngừng hoạt động'},
      {_id: 'DANG_XAY_DUNG', Name: 'Đang xây dựng'},
      {_id: 'CHUA_XAY_DUNG', Name: 'Chưa xây dựng'},
    ]
    const res = {
      success: true,
      data: IS_ENTERPRISE ? datasource : datasource.slice(0, 2),
    };
    if (res.success)
      this.setState({
        itemList: [
          SELECT_ITEM_DEFAULT,
          ...res.data.map((item) => {
            return { value: item._id, label: item.Name };
          }),
        ],
      });
  };

  render() {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };

    return (
      <Container>
        <span {...isHidden}>Ngành/Nghề</span>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <Select
            isClearable
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...getFieldProps}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-tinh-trang-hoat-dong/index.js